import { StorageList } from 'components';

export const ListPage = () => <StorageList hideTabs pageName="Storages" />;
